<!-- #166 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0 mt-4"
        style="color: #23468c; font-weight: 500"
      >
        Edit Country Setting - {{ name }}
      </div>
      <v-spacer></v-spacer>
      <!-- <v-col cols="12" md="3" class="d-flex justify-end pr-5">
        <v-select
          v-model="selectedCountryId"
          label="Country"
          class="required pt-0 mt-0"
          item-text="name"
          item-value="id"
          :items="countries"
          dense
          outlined
          hide-details
          @change="fetchList(selectedCountryId)"
        ></v-select>
      </v-col> -->
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-card>
      <v-card-title>
        <span class="body-1 font-weight-bold"
          >{{ +$route.params.id === 0 ? "Add" : "Edit" }}

          <i class="caption red--text ml-4"> * required field</i>
        </span>
      </v-card-title>
      <v-divider class="pb-3"></v-divider>
      <v-card-text class="pb-0">
        <v-form ref="form">
          <h3 class="pb-4">Area</h3>

          <v-row class="pb-0">
            <v-col cols="12" sm="4" md="4" class="pb-0">
              <v-autocomplete
                label="Area Required"
                :items="statuses"
                v-model="area"
                :rules="[(v) => typeof v === 'boolean' || 'Value is required.']"
                class="required pb-0"
                outlined
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-divider class="pb-3"></v-divider>
          <h3 class="pb-4">Zipcode</h3>

          <v-row class="pb-0">
            <v-col cols="12" sm="4" md="4" class="pb-0">
              <v-autocomplete
                label="Zipcode Required"
                :items="statuses"
                v-model="pincode"
                :rules="[(v) => typeof v === 'boolean' || 'Value is required.']"
                class="required pb-0"
                outlined
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-divider class="pb-3"></v-divider>

          <h3 class="pb-4">HS Code Validation</h3>

          <v-row class="pb-0">
            <v-col cols="12" sm="4" md="4" class="pb-0">
              <v-autocomplete
                label="HS Code Validation Required"
                :items="statuses"
                v-model="hscoderequired"
                :rules="[(v) => typeof v === 'boolean' || 'Value is required.']"
                class="required pb-0"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pb-0" v-if="hscoderequired">
              <v-autocomplete
                label="Type of HS Code Validation"
                :items="hscodes"
                v-model="hscode"
                item-text="text"
                item-value="value"
                :rules="[
                  (v) =>
                    (typeof v !== 'undefined' && v.length > 0) ||
                    'Value  is required.',
                ]"
                class="required pb-0"
                outlined
                multiple
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pb-0" v-if="hscoderequired">
              <v-autocomplete
                label="HS Code Length Validation Required"
                :items="statuses"
                v-model="hscodeLength"
                class="pb-0 required"
                outlined
                :rules="[
                  (v) =>
                    typeof v === 'boolean' || 'HS Code Length is required.',
                ]"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              sm="4"
              md="4"
              class="pb-0"
              v-if="hscodeLength && hscoderequired"
            >
              <v-text-field
                label="HS Code Minimum Length"
                v-model="minlimit"
                class="pb-0"
                outlined
                type="number"
                min="0"
                :rules="[minLimitRule]"
                @input="minLimitscheck()"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="4"
              md="4"
              class="pb-0"
              v-if="hscodeLength && hscoderequired"
            >
              <v-text-field
                label="HS Code Maximum Length"
                v-model="maxlimit"
                class="pb-0"
                outlined
                type="number"
                :min="minlimit"
                :rules="maxlimit ? [maxLimitRule] : []"
                @input="maxlimit ? validateLimits() : null"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-card-actions class="pl-0">
            <v-btn
              v-if="
                $route.params.id > 0 &&
                checkPermission('app_base:country_update_status')
              "
              color="primary"
              @click="save"
              :loading="loader"
              class="ma-0"
              >Update</v-btn
            >
            <v-btn
              v-if="$route.params.id !== 0"
              class="ml-3"
              color="error"
              @click="$router.push('/country-settings')"
            >
              Cancel
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-col>
</template>
<script>
import { mapActions } from "vuex";

export default {
  async created() {
    await this.getCountryList();
    this.getCountriesDatalist(this.$route.params.id).then((res) => {
      this.pincode = res.data.is_pincode_required;
      this.area = res.data.is_area_required;
      this.hscoderequired = res.data.hs_code_validation;
      this.name = res.data.name;
      if (
        res.data.validation &&
        typeof res.data.validation === "object" &&
        Object.keys(res.data.validation).length > 0
      ) {
        this.hscodeLength = res.data.validation.hs_code_length;
        this.minlimit = res.data.validation.hs_code_min_length;
        this.maxlimit = res.data.validation.hs_code_max_length;
        this.hscode = res.data.validation.hs_code_validation
          ? res.data.validation.hs_code_validation.split(",")
          : [];
      }
    });
    if (this.$route.params.id !== undefined)
      this.selectedCountryId = this.$route.params.id;
  },
  data() {
    return {
      name: "",
      countries: [],
      selectedCountryId: "",
      editedIndex: -1,
      selectedValues: {},
      ListSetting: [],
      hscode: [],
      area: null,
      pincode: null,
      hscodeLength: null,
      limit: null,
      minlimit: null,
      maxlimit: null,
      hscoderequired: null,
      statuses: [
        {
          text: "Yes",
          value: true,
        },
        {
          text: "No",
          value: false,
        },
      ],
      hscodes: [
        {
          text: "Alpha",
          value: "alpha",
        },
        {
          text: "Numeric",
          value: "numeric",
        },
      ],
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    options: {
      deep: true,
    },
  },

  methods: {
    ...mapActions([
      "snackBar",
      "getCountries",
      "getCountriesDatalist",
      "updatcountryeetting",
    ]),
    minLimitscheck() {
      if (this.maxlimit == undefined || this.maxlimit == "") return;

      if (Number(this.minlimit) > Number(this.maxlimit)) {
        this.minLimitRule = () =>
          "Minimum length can not be greater than maximum length";
      } else {
        this.minLimitRule = () => true;
      }
    },
    validateLimits() {
      this.maxLimitRule = (value) => {
        const isValidFormat = /^-?\d+$/.test(value);
        const isNoMinusSymbol = String(value).indexOf("-") === -1;
        return (
          (isValidFormat && isNoMinusSymbol) || "Please Enter valid value."
        );
      };
      this.minLimitRule = (value) => {
        if (value == undefined || value == "") return;
        const isValidFormat = /^-?\d+$/.test(value);
        const isNoMinusSymbol = String(value).indexOf("-") === -1;
        return (
          (isValidFormat && isNoMinusSymbol) || "Please Enter valid value."
        );
      };
      if (this.minlimit == undefined || this.minlimit == "") return;
      const isGreaterThanMinlimit =
        Number(this.maxlimit) >= Number(this.minlimit);
      if (!isGreaterThanMinlimit) {
        this.$refs.form.validate();
        return (this.maxLimitRule =
          "Max limit must be greater than or equal to min limit");
      }
    },
    getCountryList() {
      this.getCountries().then((res) => {
        this.countries = res.data;
      });
    },

    save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      if (
        this.hscoderequired &&
        this.hscodeLength &&
        !Number(this.maxlimit) &&
        !Number(this.minlimit)
      ) {
        this.$refs.form.validate();
        this.snackBar({
          color: "error",
          message: "Either Max limit or Min limit is required",
        });
        return;
      }

      this.saveLoader = true;
      let data = {
        area: this.area,
        pincode: this.pincode,
        hs_code: this.hscoderequired,
        validation: {
          hs_code_validation: this.hscode.join(","),
          hs_code_length: this.hscodeLength,
          hs_code_min_length:
            this.hscodeLength && this.minlimit ? parseInt(this.minlimit) : "",
          hs_code_max_length:
            this.hscodeLength && this.maxlimit ? parseInt(this.maxlimit) : "",
        },
      };
      if (this.hscoderequired == false) {
        data.validation = {};
      }
      let payload = {
        id: this.$route.params.id,
        data: data,
      };
      this.updatcountryeetting(payload)
        .then((res) => {
          this.saveLoader = false;
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.$router.push("/country-settings");
        })
        .catch(() => {
          this.saveLoader = false;
          this.dialog = false;
        });
    },
    close() {
      this.dialog = false;
      this.$refs.form?.reset();
    },
  },
};
</script>
<style scoped>
.file-padding {
  padding-right: 72px;
}
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 5px 5px 5px !important;
}
.v-select:not(.v-text-field--single-line):not(.v-text-field--outlined)
  .v-select__slot
  > input {
  align-self: flex-end;
}
</style>
